export const GET_CRM = "GET_CRM";
export const GET_CRM_STATS = "GET_CRM_STATS";
export const GET_CRM_ATTENTION = "GET_CRM_ATTENTION";
export const GET_CRM_BRIEFING = "GET_CRM_BRIEFING";
export const GET_CRM_OUTCOME_REPORT = "GET_CRM_OUTCOME_REPORT";

export const NEW_CRM_CUSTOMER = "NEW_CRM_CUSTOMER";

export const NEW_CRM_CUSTOMER_PRODUCT = "NEW_CRM_CUSTOMER_PRODUCT";
export const NEW_CRM_CUSTOMER_SERVICE = "NEW_CRM_CUSTOMER_SERVICE";
export const NEW_CRM_CUSTOMER_PRODUCT_TASK = "NEW_CRM_CUSTOMER_PRODUCT_TASK";
export const NEW_CRM_CUSTOMER_SERVICE_TASK = "NEW_CRM_CUSTOMER_SERVICE_TASK";

export const DELETE_CRM_CUSTOMER_PS = "DELETE_CRM_CUSTOMER_PS";
export const DELETE_CRM_CUSTOMER_PS_TASK = "DELETE_CRM_CUSTOMER_PS_TASK";

export const EDITED_CRM_CUSTOMER_PS = "EDITED_CRM_CUSTOMER_PS";
export const EDITED_CRM_CUSTOMER_PS_TASK = "EDITED_CRM_CUSTOMER_PS_TASK";

export const NEW_CRM_CUSTOMER_BASE = "NEW_CRM_CUSTOMER_BASE";

export const EDITED_CRM_CUSTOMER = "EDITED_CRM_CUSTOMER";
export const EDITED_CRM_CUSTOMER_TASK = "EDITED_CRM_CUSTOMER_TASK";

export const DELETED_CRM_CUSTOMER = "DELETED_CRM_CUSTOMER";
export const GET_CRM_CUSTOMER = "GET_CRM_CUSTOMER";
export const GET_CRM_CUSTOMER_TRADES = "GET_CRM_CUSTOMER_TRADES";
export const GET_CRM_CUSTOMER_BASE = "GET_CRM_CUSTOMER_BASE";
export const GET_CRM_CATEGORIES_BASE = "GET_CRM_CATEGORIES_BASE";

export const NEW_CRM_CATEGORY = "NEW_CRM_CATEGORY";
export const EDDITED_CRM_CATEGORY = "EDDITED_CRM_CATEGORY";
export const DELETED_CRM_CATEGORY = "DELETED_CRM_CATEGORY";
